/**
 * STICKY ADD TO CART - Version 1.1.0
 * Author: PixelUnik
 * Fix: Affiche apres 300px de scroll (ignore le bouton principal)
 */

/* global window, document, sessionStorage, fetch */
(function() {
  'use strict';

  const CONFIG = {
    wrapperSelector: '.satc-wrapper',
    variantSelectSelector: '.satc-variant-select',
    addButtonSelector: '.satc-add-button',
    closeButtonSelector: '.satc-close',
    priceSelector: '.satc-price',
    comparePriceSelector: '.satc-compare-price',
    imageSelector: '.satc-product-image img',
    qtyInputSelector: '.satc-qty-input',
    qtyMinusSelector: '.satc-qty-minus',
    qtyPlusSelector: '.satc-qty-plus',
    cartEndpoint: '/cart/add.js',
    cartGetEndpoint: '/cart.js',
    scrollThreshold: 300,
    successDuration: 2000,
    syncWithMainForm: true,
    rememberClose: true,
    closeStorageKey: 'satc_closed'
  };

  let state = {
    isVisible: false,
    isClosed: false,
    selectedVariant: null,
    quantity: 1,
    productData: null,
    lastScrollY: 0
  };

  function init() {
    const wrapper = document.querySelector(CONFIG.wrapperSelector);
    if (!wrapper) return;
    loadProductData();
    checkClosePreference();
    bindEvents();
    setTimeout(checkScroll, 100);
  }

  function loadProductData() {
    const dataScript = document.getElementById('satc-product-data');
    if (dataScript) {
      try {
        state.productData = JSON.parse(dataScript.textContent);
        const variantSelect = document.querySelector(CONFIG.variantSelectSelector);
        if (variantSelect && state.productData.variants) {
          const selectedId = parseInt(variantSelect.value);
          state.selectedVariant = state.productData.variants.find(v => v.id === selectedId);
        }
      } catch (e) {
        console.error('Error parsing product data:', e);
      }
    }
  }

  function checkClosePreference() {
    if (CONFIG.rememberClose) {
      const closed = sessionStorage.getItem(CONFIG.closeStorageKey);
      if (closed === 'true') {
        state.isClosed = true;
      }
    }
  }

  function bindEvents() {
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      if (scrollTimeout) return;
      scrollTimeout = setTimeout(() => {
        checkScroll();
        scrollTimeout = null;
      }, 50);
    }, { passive: true });

    window.addEventListener('resize', debounce(checkScroll, 100));

    const variantSelect = document.querySelector(CONFIG.variantSelectSelector);
    if (variantSelect) {
      variantSelect.addEventListener('change', handleVariantChange);
    }

    const addButton = document.querySelector(CONFIG.addButtonSelector);
    if (addButton) {
      addButton.addEventListener('click', handleAddToCart);
    }

    const closeButton = document.querySelector(CONFIG.closeButtonSelector);
    if (closeButton) {
      closeButton.addEventListener('click', handleClose);
    }

    const qtyMinus = document.querySelector(CONFIG.qtyMinusSelector);
    const qtyPlus = document.querySelector(CONFIG.qtyPlusSelector);
    const qtyInput = document.querySelector(CONFIG.qtyInputSelector);

    if (qtyMinus) qtyMinus.addEventListener('click', () => updateQuantity(-1));
    if (qtyPlus) qtyPlus.addEventListener('click', () => updateQuantity(1));
    if (qtyInput) qtyInput.addEventListener('change', handleQuantityInput);

    if (CONFIG.syncWithMainForm) syncWithMainForm();
    document.addEventListener('variant:change', handleExternalVariantChange);
  }

  function checkScroll() {
    if (state.isClosed) return;
    const wrapper = document.querySelector(CONFIG.wrapperSelector);
    if (!wrapper) return;

    const scrollThreshold = parseInt(wrapper.dataset.scrollThreshold) || CONFIG.scrollThreshold;
    const scrollY = window.scrollY;
    
    // Afficher apres le seuil de scroll seulement (ignore le bouton principal)
    const shouldShow = scrollY > scrollThreshold;

    if (shouldShow && !state.isVisible) {
      showStickyBar();
    } else if (!shouldShow && state.isVisible) {
      hideStickyBar();
    }

    state.lastScrollY = scrollY;
  }

function showStickyBar() {
  if (document.body.classList.contains('template-product-arbre-devis')) return;
  const wrapper = document.querySelector(CONFIG.wrapperSelector);
  if (wrapper) {
    wrapper.style.display = 'block';
    wrapper.offsetHeight;
    wrapper.classList.add('visible');
    state.isVisible = true;
  }
}

  function hideStickyBar() {
    const wrapper = document.querySelector(CONFIG.wrapperSelector);
    if (wrapper) {
      wrapper.classList.remove('visible');
      state.isVisible = false;
      setTimeout(() => {
        if (!state.isVisible) wrapper.style.display = 'none';
      }, 300);
    }
  }

  function handleClose() {
    state.isClosed = true;
    hideStickyBar();
    if (CONFIG.rememberClose) sessionStorage.setItem(CONFIG.closeStorageKey, 'true');
  }

  function handleVariantChange(e) {
    const variantId = parseInt(e.target.value);
    const variant = state.productData?.variants?.find(v => v.id === variantId);
    
    if (variant) {
      state.selectedVariant = variant;
      updateVariantUI(variant);
      const addButton = document.querySelector(CONFIG.addButtonSelector);
      if (addButton) {
        addButton.dataset.variantId = variantId;
        updateButtonAvailability(variant.available);
      }
      if (CONFIG.syncWithMainForm) syncVariantToMainForm(variantId);
    }
  }

  function handleExternalVariantChange(e) {
    if (e.detail && e.detail.variant) {
      const variant = e.detail.variant;
      const variantSelect = document.querySelector(CONFIG.variantSelectSelector);
      if (variantSelect) variantSelect.value = variant.id;
      state.selectedVariant = state.productData?.variants?.find(v => v.id === variant.id);
      if (state.selectedVariant) updateVariantUI(state.selectedVariant);
      const addButton = document.querySelector(CONFIG.addButtonSelector);
      if (addButton) {
        addButton.dataset.variantId = variant.id;
        updateButtonAvailability(variant.available);
      }
    }
  }

  function updateVariantUI(variant) {
    const priceEl = document.querySelector(CONFIG.priceSelector);
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    
    const comparePriceEl = document.querySelector(CONFIG.comparePriceSelector);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
    
    const imageEl = document.querySelector(CONFIG.imageSelector);
    if (imageEl && variant.image) imageEl.src = variant.image;
  }

  function updateButtonAvailability(available) {
    const addButton = document.querySelector(CONFIG.addButtonSelector);
    const buttonText = addButton?.querySelector('.satc-button-text');
    if (addButton && buttonText) {
      if (available) {
        addButton.disabled = false;
        buttonText.textContent = window.languages?.productFormAddToCart || 'Ajouter au panier';
      } else {
        addButton.disabled = true;
        buttonText.textContent = window.languages?.productFormSoldOut || 'Rupture de stock';
      }
    }
  }

  function syncWithMainForm() {
    const mainSelects = document.querySelectorAll('.product-form select, [data-product-form] select');
    const mainRadios = document.querySelectorAll('.product-form input[type="radio"], [data-product-form] input[type="radio"]');
    mainSelects.forEach(select => select.addEventListener('change', syncFromMainForm));
    mainRadios.forEach(radio => radio.addEventListener('change', syncFromMainForm));
  }

  function syncFromMainForm() {
    const mainVariantInput = document.querySelector('.product-form input[name="id"], [data-product-form] input[name="id"], .product-form select[name="id"]');
    if (mainVariantInput) {
      const variantId = parseInt(mainVariantInput.value);
      const stickySelect = document.querySelector(CONFIG.variantSelectSelector);
      if (stickySelect && stickySelect.value != variantId) {
        stickySelect.value = variantId;
        stickySelect.dispatchEvent(new Event('change'));
      }
    }
  }

  function syncVariantToMainForm(variantId) {
    const mainVariantInput = document.querySelector('.product-form input[name="id"], [data-product-form] input[name="id"]');
    if (mainVariantInput && mainVariantInput.value != variantId) {
      mainVariantInput.value = variantId;
      mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function updateQuantity(change) {
    const input = document.querySelector(CONFIG.qtyInputSelector);
    if (!input) return;
    let newValue = parseInt(input.value) + change;
    newValue = Math.max(1, Math.min(99, newValue));
    input.value = newValue;
    state.quantity = newValue;
  }

  function handleQuantityInput(e) {
    let value = parseInt(e.target.value);
    if (isNaN(value) || value < 1) value = 1;
    else if (value > 99) value = 99;
    e.target.value = value;
    state.quantity = value;
  }

  async function handleAddToCart(e) {
    e.preventDefault();
    const button = e.currentTarget;
    if (button.disabled || button.classList.contains('loading')) return;

    const variantId = button.dataset.variantId;
    const quantity = state.quantity || 1;

    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    button.classList.add('loading');
    button.disabled = true;

    try {
      const response = await fetch(CONFIG.cartEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      const data = await response.json();
      button.classList.remove('loading');
      button.classList.add('success');
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      updateCartCount();

      // Rediriger vers le panier
      setTimeout(() => {
        window.location.href = '/cart';
      }, 500);

    } catch (error) {
      console.error('Add to cart error:', error);
      button.classList.remove('loading');
      button.disabled = false;
      button.style.animation = 'satc-shake 0.3s ease';
      setTimeout(() => { button.style.animation = ''; }, 300);
    }
  }

  function updateCartCount() {
    fetch(CONFIG.cartGetEndpoint)
      .then(response => response.json())
      .then(cart => {
        const selectors = ['.cart-count', '.cart-count-bubble', '.cart-item-count', '[data-cart-count]', '.header__cart-count'];
        selectors.forEach(sel => {
          document.querySelectorAll(sel).forEach(el => {
            el.textContent = cart.item_count;
          });
        });
      })
      .catch(console.error);
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.StickyAddToCart = { init, show: showStickyBar, hide: hideStickyBar };

})();

// Animation shake
const style = document.createElement('style');
style.textContent = '@keyframes satc-shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-4px); } 75% { transform: translateX(4px); } }';
document.head.appendChild(style);